export class AwsEc2InstanceRestoreDestination {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "awsEc2",
            "baseName": "awsEc2",
            "type": "AwsEc2InstanceRestoreTarget",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AwsEc2InstanceRestoreDestination.attributeTypeMap;
    }
    constructor() {
    }
}
